// extracted by mini-css-extract-plugin
export var arrow = "layouts-components-__CardSelector-module___arrow";
export var container = "layouts-components-__CardSelector-module___container";
export var icon = "layouts-components-__CardSelector-module___icon";
export var toggle = "layouts-components-__CardSelector-module___toggle";